import { render, staticRenderFns } from "./campaigns-add-operators.vue?vue&type=template&id=0bbe083b&"
import script from "./campaigns-add-operators.vue?vue&type=script&lang=js&"
export * from "./campaigns-add-operators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports